import { render, staticRenderFns } from "./InspectionsTableByVersion.vue?vue&type=template&id=f635b984&scoped=true"
import script from "./InspectionsTableByVersion.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionsTableByVersion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionsTableByVersion.vue?vue&type=style&index=0&id=f635b984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f635b984",
  null
  
)

export default component.exports